import Vue from "vue";
import VueRouter from "vue-router";

import { SimplePage, EventList } from "event-list-components";

import App from "./App.vue";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const baseConfig = {
  assets:
    "https://www.lieblingstickets.de" +
    (process.env.NODE_ENV === "production" ? "/" : "/eXbHYRfcWXiD6fexJrtX/"),
  json:
    "https://www.lieblingstickets.de" +
    (process.env.NODE_ENV === "production"
      ? "/data/"
      : "/eXbHYRfcWXiD6fexJrtX/data/"),
  imageFilter: true,
  wdrEventImage: {
    src: require("@/assets/wdr4-logo.svg"),
    positionAfter: true,
  },
  extendedList: true,
};

const routes = [
  {
    path: "/agb",
    name: "agb",
    component: SimplePage,
    props: () => ({
      config: {
        pageName: "agb",
        ...baseConfig,
      },
    }),
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: SimplePage,
    props: () => ({
      config: {
        pageName: "datenschutz",
        ...baseConfig,
      },
    }),
  },
  {
    path: "/impressum",
    name: "impressum",
    component: SimplePage,
    props: () => ({
      config: {
        pageName: "impressum",
        ...baseConfig,
      },
    }),
  },
  {
    path: "/:filter?",
    component: EventList,
    name: "tickets",
    props: (route) => ({
      config: baseConfig,
      search: route.query.suche,
      filter: route.params.filter,
    }),
  },
];

const router = new VueRouter({
  routes,
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
